import {createGlobalStyle} from 'styled-components'

const GlobalStyle = createGlobalStyle`

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html{
    @media(max-width: 1700px){
        font-size: 75%;
    }
   
}

*::-webkit-scrollbar{
    width: 0.25rem;
}

*::-webkit-scrollbar-track{
    background: #191919;
}

*::-webkit-scrollbar-thumb{
    background: #23D997;
}


body{
    background: rgba(0,0,0,0.9);
    font-family: 'Inter', sans-serif;
}

button{
    font-weight: bold;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 1rem 2rem;
    border: 3px solid #23D997;
    background: transparent;
    color: white;
    transition: all .5s ease;
    font-family: 'Inter', sans-serif;
    text-transform: uppercase;
    letter-spacing: .25rem;

    &:hover{
        background-color: #23D997;
        color: white;
    }
    
}

h2{
        font-weight: lighter;
        font-size: 4rem;
    }
    h3{
        color: white;
    }
    h4{
    font-weight: bold;
    font-size: 2rem;
    cursor: pointer;
    }
    a{
        font-size: 1.1rem;
    }
    span{
        font-weight: bold;
        color: #23D997;
    }
    p{
        padding: 3rem 0;
        color: #ccc;
        font-size: 1.4rem;
        line-height: 150%;
    }
     
   
    
`
export default GlobalStyle